"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.decodeTokenAccountData = exports.decodeMintAccountData = exports.TokenAccount = exports.Mint = void 0;
const borsh_1 = require("@project-serum/borsh");
const buffer_layout_1 = require("buffer-layout");
exports.Mint = buffer_layout_1.struct([
    borsh_1.option(borsh_1.publicKey(), 'mintAuthority'),
    borsh_1.u64('supply'),
    buffer_layout_1.u8('decimals'),
    borsh_1.bool('initialized'),
    borsh_1.option(borsh_1.publicKey(), 'freezeAuthority'),
]);
exports.TokenAccount = buffer_layout_1.struct([
    borsh_1.publicKey('mint'),
    borsh_1.publicKey('owner'),
    borsh_1.u64('amount'),
    borsh_1.option(borsh_1.publicKey(), 'delegate'),
    buffer_layout_1.u8('state'),
    borsh_1.option(borsh_1.u64(), 'delegatedAmount'),
    borsh_1.option(borsh_1.publicKey(), 'closeAuthority'),
]);
function decodeMintAccountData(data) {
    return exports.Mint.decode(data);
}
exports.decodeMintAccountData = decodeMintAccountData;
function decodeTokenAccountData(data) {
    return exports.TokenAccount.decode(data);
}
exports.decodeTokenAccountData = decodeTokenAccountData;
//# sourceMappingURL=state.js.map